import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { AllergiesComponent } from './allergies.component';

@NgModule({
  declarations: [
    AllergiesComponent
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    AllergiesComponent
  ],
})
export class AllergiesModule { }
